import { render } from "./postCloseConnectV2.vue?vue&type=template&id=8db9ff66"
import script from "./postCloseConnectV2.vue?vue&type=script&lang=js"
export * from "./postCloseConnectV2.vue?vue&type=script&lang=js"

import "./postCloseConnectV2.vue?vue&type=style&index=0&id=8db9ff66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__